export enum AutoRunTargetType {
    Email = 0,
    FTP = 1,
}

export interface AutoRunTarget {
    id: number;
    autoRunID: number;
    autoRunScheduleID: number;
    autoRunTargetType: number; //AutoRunTargetType;
}
